import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  AppConstant,
  TranslationData,
} from 'src/app/shared/utilities/app.constant';
import { ChatMessageConfirmComponent } from './chat-message-confirm/chat-message-confirm.component';
import { ChatMessageEventComponent } from './chat-message-event/chat-message-event.component';
import { ChatMessageTextComponent } from './chat-message-text/chat-message-text.component';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  imports: [
    NgIf,
    ChatMessageTextComponent,
    ChatMessageEventComponent,
    ChatMessageConfirmComponent,
  ],
})
export class ChatMessageComponent implements OnInit, OnChanges {
  @Input() message: AppConstant.Message;
  @Input() previousMessage: AppConstant.Message | undefined;

  @Input() isMine: boolean;

  @Input() isTyping: boolean = false;
  @Input() template: 'CONTENT' | 'LOADING' = 'CONTENT';
  @Input() userPreferredLanguage: string;

  MESSAGE_TYPES = AppConstant.MessageTypes;
  SENDER_TYPES = AppConstant.SenderTypes;

  isContent: boolean = false;
  isEventSystem: boolean = false;
  isEventButton: boolean = false;
  translationData: TranslationData;

  constructor() {}

  ngOnInit(): void {
    this.isContent =
      this.isMessageType(
        this.MESSAGE_TYPES.TEXT,
        this.MESSAGE_TYPES.IMAGE,
        this.MESSAGE_TYPES.ATTACHMENT
      ) && this.message.senderType !== this.SENDER_TYPES.SYSTEM;
    this.isEventSystem =
      this.isMessageType(
        this.MESSAGE_TYPES.TEXT,
        this.MESSAGE_TYPES.IMAGE,
        this.MESSAGE_TYPES.ATTACHMENT
      ) && this.message.senderType === this.SENDER_TYPES.SYSTEM;
    this.isEventButton = this.isMessageType(
      this.MESSAGE_TYPES.ACTION_BUTTON__RESOLUTION,
      this.MESSAGE_TYPES.ACTION_BUTTON
    );

    this.computeTranslationData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] || changes['userPreferredLanguage']) {
      this.computeTranslationData();
    }
  }

  private computeTranslationData(): void {
    if (!this.message) {
      this.translationData = {
        dontNeedTranslate: false,
        dontHaveExpectedLanguage: false,
        hasTranslation: false,
        originalContent: null,
        translatedContent: null,
        userPreferredLanguage: this.userPreferredLanguage,
      };
      return;
    }

    const targetLanguageKey =
      this.userPreferredLanguage?.toLocaleLowerCase() || '';
    const translatedText =
      this.message.translations?.data?.[targetLanguageKey] || null;

    const dontNeedTranslate =
      this.userPreferredLanguage?.toLowerCase() ===
      this.message.translations?.originalLanguage?.toLowerCase();
    const dontHaveExpectedLanguage =
      !!this.userPreferredLanguage &&
      !translatedText;
    const hasTranslation = !!(!dontNeedTranslate && targetLanguageKey && translatedText);
    this.translationData = {
      dontNeedTranslate,
      dontHaveExpectedLanguage,
      hasTranslation,
      originalContent: this.message.content,
      translatedContent: hasTranslation ? translatedText : null,
      userPreferredLanguage: this.userPreferredLanguage,
    };
  }

  isMessageType(...types: AppConstant.MessageTypes[]): boolean {
    return types.includes(this.message.type as AppConstant.MessageTypes);
  }
}
